import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-paper">
      <Header />
      <main className="flex-1 pt-16 sm:pt-[74px]">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
